<template>
  <div v-if="items.length" class="row">
    <template v-for="(item, index) in items">
      <PanelCol :key="_uid + index" v-bind="item">
        <slot v-if="item.slotName" :name="item.slotName" />
      </PanelCol>
    </template>
  </div>
</template>

<script>
import { emptyArray } from '@/utils/factories';
import PanelCol from './PanelCol';

export default {
  name: 'AccountPanelRow',
  components: {
    PanelCol,
  },
  props: {
    items: {
      type: Array,
      default: emptyArray(),
    },
  },
};
</script>
